(function () {
    'use strict';

    angular.module("imApp").factory("prodGrp2MenuService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 3072,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();